import React, { useEffect } from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Badge,
  Text,
  Divider,
  HStack,
  Box,
  Spinner,
} from "@chakra-ui/react";
import { MdTranslate } from "react-icons/md";
import { useTranslationContext } from "../../context/TranslationContext";

const LanguageSelector = ({ size = "sm", variant = "ghost" }) => {
  // Use TranslationContext instead of local state
  const {
    supportedLanguages,
    getSupportedLanguages,
    targetLanguage,
    setTargetLanguage,
    isTranslating,
  } = useTranslationContext();

  useEffect(() => {
    // Load supported languages on component mount
    getSupportedLanguages();
  }, [getSupportedLanguages]);

  const handleLanguageSelect = (langCode) => {
    setTargetLanguage(langCode);
  };

  const popularLanguages = [
    "auto",
    "en",
    "nl",
    "es",
    "fr",
    "de",
    "it",
    "pt",
    "ru",
    "ja",
    "ko",
    "zh",
    "ar",
    "hi",
  ];

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        icon={
          <HStack spacing={1}>
            {isTranslating ? <Spinner size="xs" /> : <MdTranslate />}
            {targetLanguage !== "auto" && (
              <Badge
                size="sm"
                colorScheme="teal"
                variant="solid"
                fontSize="xs"
                borderRadius="full"
              >
                {targetLanguage.toUpperCase()}
              </Badge>
            )}
          </HStack>
        }
        size={size}
        variant={variant}
        colorScheme="teal"
        aria-label="Select Language"
        isLoading={isTranslating}
        _hover={{
          bg: variant === "ghost" ? "teal.50" : undefined,
        }}
      />
      <MenuList maxH="400px" overflowY="auto" minW="220px">
        <Box px={3} py={2}>
          <Text
            fontSize="xs"
            fontWeight="bold"
            color="gray.500"
            textTransform="uppercase"
          >
            Translation Language
          </Text>
        </Box>

        {/* Popular Languages */}
        <Box px={3} py={1}>
          <Text fontSize="xs" fontWeight="semibold" color="gray.600">
            Popular
          </Text>
        </Box>

        {popularLanguages.map((langCode) => (
          <MenuItem
            key={langCode}
            onClick={() => handleLanguageSelect(langCode)}
            bg={targetLanguage === langCode ? "teal.50" : "transparent"}
            color={targetLanguage === langCode ? "teal.600" : "gray.700"}
            fontWeight={targetLanguage === langCode ? "semibold" : "normal"}
            _hover={{
              bg: "teal.50",
            }}
          >
            <HStack justify="space-between" w="100%">
              <Text fontSize="sm">
                {supportedLanguages[langCode] || langCode.toUpperCase()}
              </Text>
              <Badge
                size="sm"
                variant="outline"
                colorScheme={targetLanguage === langCode ? "teal" : "gray"}
                fontSize="xs"
              >
                {langCode.toUpperCase()}
              </Badge>
            </HStack>
          </MenuItem>
        ))}

        <Divider my={2} />
        <Box px={3} py={2}>
          <Text fontSize="xs" color="gray.500">
            Current: {supportedLanguages[targetLanguage] || targetLanguage}
          </Text>
        </Box>
      </MenuList>
    </Menu>
  );
};

export default LanguageSelector;
